import 'arrive';
import $ from 'jquery';
import Swiper from 'swiper';

document.arrive('.block-hero-slider', {existing: true}, function(){
    const blockName = '.block-hero-slider';
    const sliderCP = '__slider';
    const slider = this.querySelector(`${blockName}${sliderCP}`);

    var swiper = new Swiper(slider, {
        direction: 'vertical',
        slidesPerView: 1,
        simulateTouch: false,
        noSwipingClass: 'swiper-no-swiping',
        allowTouchMove: false,
    });
});